module.exports = __webpack_public_path__ + "static/media/docker-php.72fe3ac8.png";